import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getStructureTypes = ({ denominationId }) => {
  return axios.get(`/denominations/${denominationId}/structure-types`);
};

export const useStructureTypes = ({ denominationId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["structure-types", denominationId],
    queryFn: () => getStructureTypes({ denominationId }),
    enabled: !!denominationId
  });
};
